const allTiles = {};

export const getTiles = (entityName) => {
  return allTiles[entityName];
};
